import { render } from 'react-dom';
import App from './App';

render(<App />, document.getElementById('vtr-cms'));
if (module.hot) {
  module.hot.accept();
}
